<template>
  <div class="card-app">
    <section class="room">
      <card-line slack="0.1" class="test-line top-line">
        <folded-card v-for="(card, i) in cards"
                    :key="i"
                    :orientation="card.orientation"
                    :class="{
                      'test-card': true,
                      }" 
                    is-closed="true">
          <img slot="cover-front"   class="cover-image"   :src="'assets/cards/' + card.name + '/cover.png'"
            @click="setCarousel(cards, i)">
          <!-- <img slot="backing-front" class="content-image" :src="'assets/cards/' + card.name + '/contents.png'"> -->
        </folded-card>
      </card-line>
      <card-line slack="0.15" class="test-line bottom-line" selected-card="selectedCard - cards.length">
        <photo-card v-for="(photo, i) in photos"
                    :key="i"
                    :class="{
                      'test-card': true,
                      'card--horizontal': photo.orientation == 'horizontal',
                      'card--vertical':   photo.orientation == 'vertical'
                    }" >
          <img slot="card-front"   class="cover-image"   :src="'assets/cards/photos/' + photo.name + '.jpg'"
            @click="setCarousel(photos, i)">
          <!-- <img slot="backing-front" class="content-image" :src="'assets/cards/' + photo + '.png'"> -->
        </photo-card>
      </card-line>

      <footer class="floor">
        <canvas class="floor-canvas" ref="floorCanvas"></canvas>
      </footer>
      <img class="couch" src="../assets/couch_5.png" />
    </section>
    

    <transition name="carousel-fade">
      <carousel v-if="typeof activeIndex == 'number'"
        @close="closeCarousel()"
        :type="activeType"
        :cards="activeCarousel"
        :cursor="activeIndex" />
    </transition>
  </div>
</template>

<script>
import cards from './cards.json';
import photos from './photos.json';

export default {
  methods: {
    closeCarousel() {
      window.gtag('event', 'close_carousel', { event_label: this.activeType });
      this.activeIndex = false;

    },
    setCarousel(carouselData, i) {
      this.activeIndex = i;
      this.activeCarousel = carouselData;
      window.gtag('event', 'open_carousel', { event_label: this.activeType });
    }
  },
  data() {
    return {
      activeIndex: false,
      cards, photos,
      activeCarousel: cards
    };
  },
  computed: {
    activeType() {
      return this.activeCarousel == this.cards ? 'card' : 'photo';
    }
  },
  mounted() {
    let couches = Array.from(document.getElementsByClassName('couch'));

    let show = target => couches.forEach((c, i) => c.style.display = i == target ? 'block' : 'none');
    show(0);

    let handler = e => show(Math.floor(couches.length * e.clientX / window.innerWidth));
    window.addEventListener("mousemove", handler);

    let floorCanvas = this.$refs.floorCanvas;

    floorCanvas.width = floorCanvas.clientWidth;
    floorCanvas.height = floorCanvas.clientHeight;

    const ctx = floorCanvas.getContext("2d");

    let img = new Image();
    img.src = 'assets/floor-tex.jpg';
    img.onload = () => {

      ctx.fillStyle = "#ff00ff";
      ctx.fillRect(0, 0, floorCanvas.width, floorCanvas.height);

      let scale = 200 / img.width;
      let invScale = 1 / scale;
      ctx.scale(scale, scale);
      let pattern = ctx.createPattern(img, "repeat");
      ctx.fillStyle = pattern;
      ctx.fillRect(0, 0, invScale*floorCanvas.width, invScale*floorCanvas.height);
      // ctx.fillRect(0, 0, 400, 400);
    };

    
  }
  
}
</script>

<style lang="scss">

body {
  min-height: 100vh;
  background-image: url("../assets/white_wall.png");

}

.card-app {
  position: relative;
  padding-top: 100px;
  
  min-height: 100vh;
  overflow: hidden;
}

$perspective: 500px;
.room {
  perspective: $perspective;
  perspective-origin: center 100px;
}

.floor {
  position: absolute;
  top: 100%;
  left: -10%;
  z-index: -1;
  height: $perspective + 80px;
  width: 120%;
  transform-origin: top center;
  transform: translateZ(-80px) rotateX(89deg); // firefox doesn't like a 90deg rotation here..

  &:before {
    content: "";
    display: block;
    height: 10px;
    position: absolute;
    bottom: 100%;
    width: 100%;
    background: #ddc;
    box-shadow: 0 4px 2px -1.5px #eec inset, 0 5px 5px -1.5px white inset,;
    transform-origin: bottom center;
    transform: rotateX(-90deg);
  }
}

.floor-canvas {
  width: 100%;
  height: 100%;
}

@media (min-width: 1080px) {
  body {
    perspective-origin: center 540px;

  }

  
}

.card-panel,
.card-panel-cover,
.card-panel-back { cursor: pointer; }


$br: 1%;
.card-folded {

  &.card--horizontal {
    .card-side-back,
    .card-side-front { border-radius: 0 0 $br $br; }
  }
  &.card--vertical {
    .card-side-front { border-radius: 0 $br $br 0; }
    .card-side-back  { border-radius: $br 0 0 $br; }
  }
}
.card-flat {
    .card-side-front,
    .card-side-back  { border-radius: $br; }
}

.card-flat {
  padding: 2%;
  background-color: white;
  border-radius: 1*$br;

  .carousel-container & {

  }
}

.cover-image,
.content-image {
  width: 100%;
  height: 100%;
  background-size: cover;
  border-radius: inherit;
}


$target-line-width: 70vw;
$max-line-width: 900px;

$top-items: 8;
$target-top-card-width:  $target-line-width*(1 / ($top-items + 1));
   $max-top-card-width:     $max-line-width*(1 / ($top-items + 1));
$target-top-card-height: $target-top-card-width*(5/7);
   $max-top-card-height:    $max-top-card-width*(5/7);

$bottom-items: 8;
$target-bottom-card-width:  $target-line-width*(1 / ($bottom-items + 1));
   $max-bottom-card-width:     $max-line-width*(1 / ($bottom-items + 1));
$target-bottom-card-height: $target-bottom-card-width*(5/7);
   $max-bottom-card-height:    $max-bottom-card-width*(5/7);

.test-line {
  width:     $target-line-width;
  max-width:    $max-line-width;
  height:    $target-line-width / 3;
  max-height:   $max-line-width / 3;
  margin: 0 auto;
}

$target-top-width: 60vw;
   $max-top-width: 900px*60/70;
.top-line {
  width:     $target-top-width;
  max-width:    $max-top-width;
  
  height:     $target-top-width / 4;
  max-height:    $max-top-width / 4;

  .card--vertical {
    width:      $target-top-card-height;
    max-width:     $max-top-card-height;
    height:     $target-top-card-width;
    max-height:    $max-top-card-width;
  }

  .card--horizontal {
    width:      $target-top-card-width;
    max-width:     $max-top-card-width;
    height:     $target-top-card-height;
    max-height:    $max-top-card-height;
  }
}

.bottom-line {
  .card--vertical {
    width:      $target-bottom-card-height;
    max-width:     $max-bottom-card-height;
    height:     $target-bottom-card-width;
    max-height:    $max-bottom-card-width;
  }

  .card--horizontal {
    width:      $target-bottom-card-width;
    max-width:     $max-bottom-card-width;
    height:     $target-bottom-card-height;
    max-height:    $max-bottom-card-height;
  }
}

.test-rotatoscope {
  position: absolute;
  top: 10px;
  left: calc(50% - 250px);
  width: 500px;
  height: 500px;
}


.couch {
  display: block;
  padding-top: 6%;
  margin-left: 50%;
  transform: translateX(-50%) translateZ(1px); // x to center it, z for sorting in safari and ff
  max-width: 120vw;
}


.carousel-container {
  transition: all .5s;
}


.carousel-container.carousel-fade-enter,
.carousel-container.carousel-fade-leave-to {
  opacity: 0;
  padding-top: 50vh;

}
</style>



// WEBPACK FOOTER //
// app.vue?b7116fdc